module.exports = __webpack_public_path__ + "img/dark.2d056383.svg";